import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UserManagedSearchComponent.css';
import { Search } from '@material-ui/icons';
import {
  TextField, FormControl, Select, MenuItem, Button,
} from '@material-ui/core';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import { setSystemLodingFLg, setErrorMessage } from '../../actions/CommonAction';
import {
  setSearchUserId, setSearchUserName,
  setSearchRole, setSortItem, setSortOrder, setNowPage,
  setUserResultList,
  searchUserList, setResetUserList,
} from '../../actions/UserManagedAction';
import { SORT_ITEM, SORT_ORDER } from '../../../common/const';

class UserManagedSearchComponent extends Component {
  constructor() {
    super();
    this.state = {
      errSearchUserId: null,
      errSearchUserName: null,
      errSearchUserIdFlg: false,
      errSearchUserNameFlg: false,
    };
  }

  /**
   * 検索用ユーザーIDのバリデーションチェック
   */
  onBlurSearchUserID = () => {
    const {
      searchUserId,
    } = this.props;

    // ユーザーIDの入力チェック
    const msgs = [];
    this.checkUserId(searchUserId, msgs);
  }

  /**
   * 検索用ユーザー名のバリデーションチェック
   */
  onBlurSearchUserName = () => {
    const {
      searchUserName,
    } = this.props;

    // 検索用ユーザー名の入力チェック
    const msgs = [];
    this.checkUserName(searchUserName, msgs);
  }

  /**
   * 検索ボタン押下時の処理
   */
  onClickSearchButton = async () => {
    // 入力チェックを行う。
    const {
      setSystemLodingFlgAct,
      searchUserId,
      searchUserName,
      searchRole,
      setSortItemAct,
      setSortOrderAct,
      setNowPageAct,
      setUserResultListAct,
      searchUserListAct,
      setErrorMessageAct,
    } = this.props;
    const msgs = [];
    // 検索条件が全て未選択の場合、エラーメッセージを表示
    if (!((searchUserId && searchUserId.length > 0)
      || (searchUserName && searchUserName.length > 0)
      || (searchRole && searchRole.length > 0)
    )) {
      setErrorMessageAct(getMessage(ERROR.E04001));
      return;
    }
    if (this.checkUserId(searchUserId, msgs)) {
      return;
    }
    if (this.checkUserName(searchUserName, msgs)) {
      return;
    }
    await setSortItemAct(SORT_ITEM.USER_ID);
    await setSortOrderAct(SORT_ORDER.ASC);
    await setNowPageAct(1);

    const {
      sortItem,
      sortOrder,
      nowPage,
      setResetUserListAct,
    } = this.props;

    // ユーザー情報検索APIを呼び出す。
    setSystemLodingFlgAct(true);
    const response = await searchUserListAct(
      searchUserId,
      searchUserName,
      searchRole,
      sortItem,
      sortOrder,
      nowPage,
    );
    setResetUserListAct([]);
    setSystemLodingFlgAct(false);
    setUserResultListAct(response);
  }

  /**
   * ユーザーID入力チェック
   * @param {string} userId 検証するユーザーID
   * @param {[]} msgs メッセージ
   * @returns 判定結果(true：入力誤り、false：正しい入力)
   */
  checkUserId = (userId, msgs) => {
    // 検索用ユーザーIDの入力チェック
    validator.checkMaxLength(userId, 20, msgs);
    validator.checkChar(userId, VALIDATOR_CONST.PATERN_ALPHABET_NUM, msgs);
    // 入力誤りがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errSearchUserId: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errSearchUserIdFlg: true });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errSearchUserId: '' });
    this.setState({ errSearchUserIdFlg: false });
    return false;
  }

  /**
   * ユーザー名入力チェック
   * @param {string}} userName 検証するユーザー名
   * @param {[]} msgs メッセージ
   * @returns 判定結果(true：入力誤り、false：正しい入力)
   */
  checkUserName = (userName, msgs) => {
    // 検索用ユーザー名の入力チェック
    validator.checkMaxLength(userName, 50, msgs);
    // 入力誤りがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errSearchUserName: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errSearchUserNameFlg: true });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errSearchUserName: '' });
    this.setState({ errSearchUserNameFlg: false });
    return false;
  }

  render() {
    const {
      searchUserId,
      searchUserName,
      searchRole,
      roleList,
      setSearchUserIdAct,
      setSearchUserNameAct,
      setSearchRoleAct,
    } = this.props;
    const {
      errSearchUserId,
      errSearchUserName,
      errSearchUserIdFlg,
      errSearchUserNameFlg,
    } = this.state;
    return (
      <div className="userManagedSearch">
        <div className="content">
          <div className="headerfield">
            <div className="subTitle">検索条件</div>
          </div>
          <div className="large_title">ユーザーID</div>
          <div>
            <TextField
              className="same_text"
              inputProps={{ className: 'inputSizing' }}
              variant="outlined"
              margin="normal"
              value={searchUserId || ''}
              onChange={(ev) => setSearchUserIdAct(ev.target.value)}
              onBlur={this.onBlurSearchUserID}
              error={errSearchUserIdFlg}
            />
          </div>
          <div className="errmessage">{errSearchUserId}</div>
          <div className="large_title">ユーザー名</div>
          <div>
            <TextField
              className="same_text"
              inputProps={{ className: 'inputSizing' }}
              variant="outlined"
              margin="normal"
              value={searchUserName || ''}
              onChange={(ev) => setSearchUserNameAct(ev.target.value)}
              onBlur={this.onBlurSearchUserName}
              error={errSearchUserNameFlg}
            />
          </div>
          <div className="errmessage">{errSearchUserName}</div>
          <div className="large_title">権限</div>
          <div>
            <FormControl className="selectMaxSizing" variant="outlined">
              <Select
                className="same_select"
                value={searchRole || ''}
                onChange={(ev) => setSearchRoleAct(ev.target.value)}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 30, horizontal: 0 },
                  PaperProps: {
                    className: 'selectStyle',
                  },
                }}
              >
                <MenuItem key="" value="">　</MenuItem>
                {roleList
                  && roleList.map((roleset) => (
                    <MenuItem
                      key={roleset.role_code}
                      value={roleset.role_code}
                    >
                      {roleset.role_name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

          </div>
          <div className="search">
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Search />}
              onClick={this.onClickSearchButton}
              disabled={(searchUserId === null || searchUserId === '')
                && (searchUserName === null || searchUserName === '')
                && (searchRole === null || searchRole === '')}
            >
              検索
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    roleList: state.usermanaged.roleList,
    searchUserId: state.usermanaged.searchUserId,
    searchUserName: state.usermanaged.searchUserName,
    searchRole: state.usermanaged.searchRole,
    sortItem: state.usermanaged.sortItem,
    sortOrder: state.usermanaged.sortOrder,
    nowPage: state.usermanaged.nowPage,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setSearchUserIdAct: (str) => dispatch(setSearchUserId(str)),
    setSearchUserNameAct: (str) => dispatch(setSearchUserName(str)),
    setSearchRoleAct: (str) => dispatch(setSearchRole(str)),
    setSortItemAct: (str) => dispatch(setSortItem(str)),
    setSortOrderAct: (str) => dispatch(setSortOrder(str)),
    setNowPageAct: (str) => dispatch(setNowPage(str)),
    setUserResultListAct: (str) => dispatch(setUserResultList(str)),
    setErrorMessageAct: (str) => dispatch(setErrorMessage(str)),
    setResetUserListAct: (strarr) => dispatch(setResetUserList(strarr)),
    searchUserListAct: (
      userId, userName, role, sortItem, sortOrder, pageNumber,
    ) => dispatch(searchUserList(
      userId, userName, role, sortItem, sortOrder, pageNumber,
    )),
  }),
)(UserManagedSearchComponent);
